import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { titleCase } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { Briefcase } from "@phosphor-icons/react";

const STATUS_CLS = {
  interested: "bg-slate-100 text-slate-700",
  preparing: "bg-blue-50 text-blue-700 border-blue-200",
  applied: "bg-indigo-50 text-indigo-700 border-indigo-200",
  interview: "bg-amber-50 text-amber-700 border-amber-200",
  offer: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  withdrawn: "bg-slate-100 text-slate-500",
};

export default function Applications() {
  const [apps, setApps] = useState([]);
  useEffect(() => { api.get("/applications").then((r) => setApps(r.data.applications)); }, []);

  return (
    <div>
      <PageHeader title="Applications" subtitle="Track every role you're pursuing, from interest through outcome." />
      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden" data-testid="applications-list">
        {apps.length === 0 && (
          <div className="p-10 text-center">
            <Briefcase size={32} className="mx-auto text-slate-300" />
            <p className="mt-3 text-sm text-slate-500">No applications yet. Open a job and prepare an application to start tracking.</p>
            <Link to="/jobs" className="mt-3 inline-block text-sm font-medium text-slate-900 underline">Find jobs</Link>
          </div>
        )}
        {apps.map((a) => (
          <div key={a.id} className="flex items-center gap-4 px-5 py-4 border-b border-slate-100 last:border-0" data-testid={`app-${a.id}`}>
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-slate-900 truncate">{a.job?.title || "Job"}</p>
              <p className="text-sm text-slate-600 truncate">{a.job?.employer}{a.job?.country ? ` · ${a.job.country}` : ""}</p>
              {a.notes && <p className="text-xs text-slate-400 mt-1 truncate">{a.notes}</p>}
            </div>
            <Badge variant="outline" className={`font-medium border ${STATUS_CLS[a.status] || STATUS_CLS.interested}`}>{titleCase(a.status)}</Badge>
            <Link to={`/jobs/${a.job_id}`} className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid={`app-open-${a.id}`}>Open</Link>
          </div>
        ))}
      </div>
    </div>
  );
}
